import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import Tooltip from "@mui/material/Tooltip";
import Colors from "../../../assets/styles/Colors";

function MenuDropdownButton({
  openCollapse,
  submenu,
  handleOpenSettings,
  handleClick,
  item,
  open,
  openD,
  expired,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const active = submenu.some((entry) => entry.route === location.pathname);

  const content = (
    <List disablePadding sx={{ opacity: expired ? 0.38 : 1, pointerEvents: expired ? "none" : "auto" }}>
      <ListItemButton
        sx={{
          minHeight: 42,
          justifyContent: open ? "initial" : "center",
          px: open ? 1.5 : 1,
          mx: open ? 0.5 : 0.25,
          my: 0.35,
          borderRadius: 2,
          border: active ? "1px solid rgba(151, 71, 255, 0.34)" : "1px solid transparent",
          backgroundColor: active ? "rgba(151, 71, 255, 0.10)" : "transparent",
          color: active ? Colors.white : Colors.textSecondary,
          transition: "background-color 160ms ease, border-color 160ms ease, color 160ms ease",
          "&:hover": {
            backgroundColor: active ? "rgba(151, 71, 255, 0.16)" : "rgba(255,255,255,0.055)",
            color: Colors.white,
          },
        }}
        onClick={() => !expired && handleClick(item.id)}
        key={item.id}
      >
        {item.icon && (
          <ListItemIcon sx={{ minWidth: 0, mr: open ? 1.5 : "auto", justifyContent: "center", color: active ? Colors.primaryLight : "currentColor", fontSize: 20 }}>
            {item.icon}
          </ListItemIcon>
        )}
        <ListItemText
          primary={item.title}
          sx={{ opacity: open ? 1 : 0, minWidth: 0, m: 0 }}
          primaryTypographyProps={{ noWrap: true, sx: { overflow: "hidden", textOverflow: "ellipsis", fontSize: 13, fontWeight: active ? 800 : 600 } }}
        />
        {openD[item.id] ? (
          <ExpandLess sx={{ color: "currentColor", fontSize: 20 }} />
        ) : (
          <ExpandMore sx={{ color: "currentColor", fontSize: 20 }} />
        )}
      </ListItemButton>

      <Collapse in={openD[item.id]} timeout="auto" unmountOnExit>
        {submenu.map((sub) => (
          <List component="div" disablePadding key={sub.title}>
            <ListItemButton
              onClick={() => !expired && navigate(sub.route)}
              sx={{
                minHeight: 38,
                pl: open ? 4.75 : 1.5,
                pr: open ? 1.25 : 1,
                mx: open ? 0.5 : 0.25,
                my: 0.25,
                borderRadius: 2,
                color: sub.route === location.pathname ? Colors.white : Colors.textSecondary,
                backgroundColor: sub.route === location.pathname ? "rgba(151, 71, 255, 0.14)" : "transparent",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.055)", color: Colors.white },
              }}
            >
              <ListItemIcon sx={{ color: "currentColor", minWidth: 0, mr: 1.5 }}>{sub.icon}</ListItemIcon>
              <ListItemText
                primary={sub.title}
                sx={{ minWidth: 0, m: 0 }}
                primaryTypographyProps={{ noWrap: true, sx: { overflow: "hidden", textOverflow: "ellipsis", fontSize: 12.5, fontWeight: sub.route === location.pathname ? 800 : 600 } }}
              />
            </ListItemButton>
          </List>
        ))}
      </Collapse>
    </List>
  );

  if (expired) {
    return (
      <Tooltip title="Pago vencido — contactá a soporte" placement="right" arrow>
        <span style={{ display: "block" }}>{content}</span>
      </Tooltip>
    );
  }

  return content;
}

export default MenuDropdownButton;
